import { render, staticRenderFns } from "./mydiagnosisOrder.vue?vue&type=template&id=5e890210&scoped=true"
import script from "./mydiagnosisOrder.vue?vue&type=script&lang=js"
export * from "./mydiagnosisOrder.vue?vue&type=script&lang=js"
import style0 from "./mydiagnosisOrder.vue?vue&type=style&index=0&id=5e890210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e890210",
  null
  
)

export default component.exports